import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'quitting_feelings'

const OPTIONS = [
  {
    value: 'anxious',
    translationKey: 'pages.onboarding.quittingFeelings.options.anxious',
  },
  {
    value: 'curious',
    translationKey: 'pages.onboarding.quittingFeelings.options.curious',
  },
  {
    value: 'ready',
    translationKey: 'pages.onboarding.quittingFeelings.options.ready',
  },
  {
    value: 'confident',
    translationKey: 'pages.onboarding.quittingFeelings.options.confident',
  },
  {
    value: 'not-sure',
    translationKey: 'pages.onboarding.quittingFeelings.options.not-sure',
  },
]

const ANSWER_TEXTS = {
  anxious: 'I feel anxious and unsure',
  curious: "I'm curious, but not committed yet",
  ready: 'I feel ready to try',
  confident: "I'm confident and motivated",
  'not-sure': "I'm not sure how I feel",
}

export default function QuittingFeelingsPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && Object.keys(ANSWER_TEXTS).includes(value) ? value : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const answerValue = formData.get('answer') as string

    if (!answerValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'What best describes how you feel about quitting today?',
      answer_key: answerValue,
      answer: ANSWER_TEXTS[answerValue as keyof typeof ANSWER_TEXTS],
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  const buttons = OPTIONS.map((option) => ({
    text: t(option.translationKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.quittingFeelings.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
